
export function DashboardHeader() {
  return (
    <div >
      <p className="page-title">System Admin Dashboard</p>
      <p className="page-subtitle">
        Welcome back! Here's an overview of your system performance and user adoption.
      </p>
    </div>
  );
}
